// import isSiteBuilder from './isSiteBuilder';

export default function getStage(){
    // if(isSiteBuilder()) return "dev";
    // if(process.env.REACT_APP_ENVIRONMENT === 'production') return "master";
    if(window.OrendaStage) return window.OrendaStage;
    return "dev";
}